import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import Link from '../../routing/components/Link';
import dateHelper from '../../../helpers/dateHelper';

class ArticleLanguages extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    let self = this;
    let {articleVersions, lang, articleId} = this.props;

    if (articleVersions.item.length === 0) {
      return <em><FormattedMessage id="noVersions"/></em>;
    }
    if (articleVersions.item.length === 1) {
      return <em><FormattedMessage id="onlyOneArticleVersion"/></em>;
    }

    return (
      <div>
        {articleVersions.item.map(item => {
          if (item.id === articleId) {
            return (<div key={articleId}>
              <span>{dateHelper.formatDate(item.attributes.date, lang)}: <FormattedMessage
                id="currentVersion"/></span>
            </div>);
          }
          return (<div key={item.id}>
            <Link
              url={self.props.location.pathname.replace(/index$/, item.attributes.date)}>
              {dateHelper.formatDate(item.attributes.date, lang)}
            </Link>
          </div>);
        })}
      </div>
    );
  }
}

ArticleLanguages.propTypes = {
  lang: PropTypes.string,
  articleId: PropTypes.string,
  articleVersions: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  const {articleVersions, article} = state;
  const {lang, articleId} = ownProps.params;
  let myArticleVersions = JSON.parse(JSON.stringify(articleVersions));
  if (myArticleVersions.item) {
    myArticleVersions.item.push({
      id: articleId,
      attributes: {date: article.item ? article.item.attributes.date_version : dateHelper.formatToApi(new Date(), 'X'), 'version_comment': article.item ? article.item.attributes.version_comment : dateHelper.formatDate(article.item.attributes.date_version, lang)}
    });
    myArticleVersions.item.sort((a, b) => {
      return b.attributes.date.localeCompare(a.attributes.date);
    });
  }
  return {
    lang,
    articleId,
    articleVersions: myArticleVersions
  };
}

export default connect(mapStateToProps)(ArticleLanguages);



/** WEBPACK FOOTER **
 ** ./src/modules/articles/components/ArticleVersions.js
 **/